// removed by extract-text-webpack-plugin
module.exports = {"container":"container__330y8"};


//////////////////
// WEBPACK FOOTER
// ./components/content/content.css
// module id = SFgq
// module chunks = 0